module.exports = __webpack_public_path__ + "static/media/checkbox_check.2a5e506e.svg";